export default "__VITE_ASSET__65e9402a__"